import classes from './PromoCodeForm.module.css';
import Form from '../../UI/Form/Form';
import Input from '../../UI/Input/Input';
import Select from '../../UI/Select/Select';
import Button from '../../UI/Button/Button';
import { PromoCode, Option } from '../../../types/common';

interface Props {
    value: Partial<PromoCode>;
    errors: { [k: string]: string | undefined };
    onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onSelect: (option: { [key: string]: string }) => void;
    onClose: () => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    isEditMode: boolean;
}

const PromoCodeForm: React.FC<Props> = ({ value, errors, onInputChange, onSelect, onClose, onSubmit, isEditMode }) => {
    const discountTypeOptions: Option[] = [
        { id: 'percentage', name: 'Проценты', url: '' },
        { id: 'points', name: 'Баллы', url: '' },
    ];
    const promoTypeOptions: Option[] = [
        { id: 'global', name: 'Общий', url: '' },
        { id: 'personal', name: 'Персональный', url: '' },
    ];
    const statusOptions: Option[] = [
        { id: 'active', name: 'Активен', url: '' },
        { id: 'inactive', name: 'Неактивен', url: '' },
    ];

    const optionName = (arr: Option[], id?: string) => arr.find((o) => o.id === id)?.name || '';

    return (
        <div className={classes.wrapper}>
            <Form onSubmit={onSubmit}>
                <>
                    <Input
                        label="Ключ промо-кода"
                        name="code"
                        type="text"
                        value={value.code || ''}
                        onChange={onInputChange}
                        errorText={errors.code}
                        required
                        isDisabled={isEditMode}
                        placeholder="Например SUMMER25"
                    />

                    {!isEditMode && (
                        <>
                            <Select
                                label="Тип скидки"
                                options={discountTypeOptions}
                                defaultOptionText="Выберите тип"
                                required
                                value={optionName(discountTypeOptions, value.discountType)}
                                field="discountType"
                                onSelect={onSelect}
                                errorText={errors.discountType}
                            />

                            <Input
                                label="Размер скидки"
                                name="discountValue"
                                type="number"
                                value={String(value.discountValue) ?? ''}
                                onChange={onInputChange}
                                errorText={errors.discountValue}
                                required
                                min={1}
                                max={value.discountType === 'percentage' ? 100 : 10000}
                                placeholder={value.discountType === 'percentage' ? '1-100' : '1-10000'}
                            />

                            <Select
                                label="Тип промо-кода"
                                options={promoTypeOptions}
                                defaultOptionText="Выберите тип"
                                required
                                value={optionName(promoTypeOptions, value.type)}
                                field="type"
                                onSelect={onSelect}
                                errorText={errors.type}
                            />

                            {value.type === 'personal' && (
                                <Input
                                    label="Номер телефона"
                                    name="phone"
                                    type="tel"
                                    value={value.phone || ''}
                                    onChange={onInputChange}
                                    errorText={errors.phone}
                                    required
                                    placeholder="+79991234567"
                                />
                            )}

                            {value.type === 'global' && (
                                <Input
                                    label="Лимит использований"
                                    name="usageLimit"
                                    type="number"
                                    value={String(value.usageLimit) ?? ''}
                                    onChange={onInputChange}
                                    errorText={errors.usageLimit}
                                    required
                                    min={1}
                                    max={10000}
                                    placeholder="1-10000"
                                />
                            )}
                        </>
                    )}

                    {isEditMode && (
                        <Select
                            label="Статус"
                            options={statusOptions}
                            defaultOptionText="Статус"
                            required
                            value={optionName(statusOptions, value.status)}
                            field="status"
                            onSelect={onSelect}
                            errorText={errors.status}
                        />
                    )}

                    <div className={classes.actions}>
                        <Button mode="secondary" onClick={onClose}>
                            Отмена
                        </Button>
                        <Button mode="primary" type="submit">
                            Сохранить
                        </Button>
                    </div>
                </>
            </Form>
        </div>
    );
};

export default PromoCodeForm;
